import styled from "styled-components";

export const SideNavContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top:10px;
    width: 25%;
`;

export const SideNavItems = styled.div<{active: boolean}>`
    cursor:pointer;
    margin:5px;
    color:${(({active})=> active ?  'white' : 'rgb(175, 175, 175)')};
    font-size: ${(({active})=> active ?  '22px' : '20px')};
    transition: all 0.15s ease;
    &:hover {
        color: white;
        font-size: 22px;
    }
    &:active {
        transform: scale(0.97);
    }
`;

export const HomeButton = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  cursor: pointer;
  font-size: 20px;
  color: rgb(175, 175, 175);
  display: flex;
  align-items: center;
  transition: all 0.15s ease;

  &:hover {
    color: white;
    font-size: 22px;
  }

`;

